import { createGlobalStyle } from "styled-components"

export const lightTheme = {
  fontFamily: "var(--ff-secondary)",
  fontSize: "0.875rem",
  body: "#F9FCFF",
  fontColor: "#051221",
  fontWight: 800,
  background: "rgba(2, 62, 138,0.9)",
  contentBackground: "var(--clr-white)",
  educationBackground: "#F1F1E6",
  serviceBackground: "#e2e2f3",
  contentColor: "#270B01",
  headerColor: "#051221",
  tagBackground: "var(--clr-grey-9)",
  tagColor: "var(--clr-grey-5)",
  buttonColor: "var(--clr-primary-5)",
  navBorder: "rgba(0, 0, 0, 0.2)",
}

export const darkTheme = {
  fontFamily: "var(--ff-secondary)",
  fontSize: "0.875rem",
  body: "#051221",
  fontColor: "#A2C3C6",
  background: "#051221",
  contentBackground: "#071C34",
  educationBackground: "#0c2036",
  serviceBackground: "#021730;",
  contentColor: "#D6D7D8",
  headerColor: "#7FB1EC",
  tagBackground: "#33425E",
  tagColor: "#BDCCEE",
  buttonColor: "var(--clr-primary-5)",
  navBorder: "rgba(255,255, 255, 0.1)",
}

export const GlobalStyles = createGlobalStyle`
body{
    background-color:${({ theme }) => theme.body};
    color:${({ theme }) => theme.fontColor};
}
`
